'use strict';

exports.__esModule = true;
exports.ProfileListItem = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ProfileListItem(props) {
	var profile = props.profile,
	    currentProfile = props.currentProfile,
	    onProfileClicked = props.onProfileClicked;

	return _react2.default.createElement(
		'li',
		null,
		_react2.default.createElement(
			'a',
			{ href: '/' + profile.type + '/' + profile.uri_id + '/edit/profile', onClick: function onClick() {
					onProfileClicked(profile);
				} },
			profile.name,
			profile.id === currentProfile.id && _react2.default.createElement('i', { className: 'ion-checkmark' })
		)
	);
}

ProfileListItem.propTypes = {
	profile: require('react').PropTypes.any.isRequired,
	currentProfile: require('react').PropTypes.any.isRequired,
	onProfileClicked: require('react').PropTypes.func.isRequired
};
exports.ProfileListItem = ProfileListItem;


// WEBPACK FOOTER //
// ./components/top-nav/lib/components/profile-list-item.js